(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/slicedToArray', 'react', './index'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/slicedToArray'), require('react'), require('./index'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.slicedToArray, global.react, global.index);
    global.useIntercom = mod.exports;
  }
})(this, function (exports, _extends2, _slicedToArray2, _react, _index) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends3 = _interopRequireDefault(_extends2);
  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var useIntercom = function useIntercom(appID) {
    if (!appID) {
      console.warn('appID is required. Make sure you pass in the Intercom Workspace app_id (eg. - useIntercom(appId)).');
      return null;
    }
    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isBooted = _useState2[0],
      setIsBooted = _useState2[1];
    var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      checkBootState = _useState4[0],
      setCheckBootState = _useState4[1];
    var intercom = _index.IntercomAPI;
    (0, _react.useEffect)(function () {
      var interval = void 0,
        timeout = void 0;
      if (checkBootState) {
        timeout = setTimeout(function () {
          clearInterval(interval);
          setIsBooted(false); // Intercom is not booted!
        }, 10000);
        interval = setInterval(function () {
          if (window.Intercom && window.Intercom.booted) {
            setIsBooted(true); // Intercom is booted!
            clearInterval(interval);
            clearTimeout(timeout);
          }
        }, 500);
      }
      return function () {
        setIsBooted(true);
        clearInterval(interval);
        clearTimeout(timeout);
      };
    }, [checkBootState]);
    var boot = function boot(intercomSettings) {
      intercom('boot', (0, _extends3.default)({
        app_id: appID
      }, intercomSettings));
      setCheckBootState(true);
    };
    var update = function update() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      intercom('update', (0, _extends3.default)({}, data));
    };
    var shutdown = function shutdown() {
      intercom('shutdown');
      setCheckBootState(true);
    };
    return {
      boot: boot,
      intercom: intercom,
      shutdown: shutdown,
      update: update,
      isBooted: isBooted
    };
  };
  exports.default = useIntercom;
});